// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-table-block {
  background-color: #F5F5F5;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  overflow-x: auto;
}

.no-lesson-img {
  width: 100%;
  max-width: 100%;
  height: auto;
}

::-webkit-scrollbar {
  width: 10px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: #ebebeb;
  border: 4px solid transparent;
  background-clip: content-box;
  top: 0;
}

::-webkit-scrollbar-thumb {
  background: #495471;
  border-radius: 29px;
}

.schedule-table {
  background-color: #434C63;
  width: 100%;
  border-collapse: collapse;
}

.schedule-table_mobile {
  display: none;
}

.table-header {
  height: 60px;
  font-size: 18px;
  background-color: #434C63;
}

.table-header th:first-child {
  border-top-left-radius: 12px;
}

.table-header th:last-child {
  border-top-right-radius: 12px;
}

.table-header_item {
  padding: 20px 20px;
  color: #FFFFFF;
  border-right: 1px solid #ffffff;
}

.table-body_row {
  position: relative;
}

.table-body_row_item {
  height: 60px;
  text-align: center;
  background-color: white;
  border: 1px solid #E2E8F0;
}

.table-body_row_item.lesson_number {
  width: 4%;
}

.lecture_row {
  border-left: 5px solid #52f652;
}

.lab_work_row {
  border-left: 5px solid #fd4b4b;
}

.practice_row {
  border-left: 5px solid #ffb024;
}

.consultation_row {
  border-left: 5px solid #52b7f6;
}

.exam_row {
  border-left: 5px solid #1812d5;
}

/*.table-body_row_item.no_lessons {*/
/*  border-left: 8px solid #a2a2a2;*/
/*}*/

.teacher_link {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color linear .2s;
}

.teacher_link:hover {
  color: #ffd03f;
  text-decoration: underline;
}

.teacher_cell_img {
  margin-right: 5px;
  width: 45px;
  height: 45px;
}

.teacher_cell_img:hover {
  cursor: pointer;
}

.MONDAY, .WEDNESDAY, .FRIDAY, .SUNDAY {
  background-color: #FFFFFF;
}

.TUESDAY, .THURSDAY, .SATURDAY {
  background-color: #f1f1f1;
}

@media screen  and (max-width: 520px) {
  .schedule-table-block {
    overflow-x: hidden;
  }

  .schedule-table {
    display: none;
  }

  .schedule-table_mobile {
    margin-top: 40px;
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    max-width: 420px;
  }

  .mobile-table-container {
    display: flex;
    flex-direction: column;
  }

  .mobile-card {
    margin-bottom: 35px;
    width: 420px;
    border: 1px solid #cecfd0;
  }

  .block_no_lessons {
    margin: 0 auto;
    padding: 20px 0;
  }

  .card-divider {
    margin-bottom: 20px;
    width: 100%;
    height: 1px;
    background-color: #a2a2a2;
  }

  .card-inner {
    padding-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .card-text.discipline-name {
    font-weight: 500;
    font-size: 24px;
    color: #494A4A;
  }

  .card-text-key {
    color: #494A4A;
    padding-right: 5px;
  }

  .card-text {
    padding-left: 28px;
    padding-bottom: 20px;
    font-size: 18px;
    font-weight: 400;
    line-height: 22px;
    color: #505050;
  }

  .block_description_name {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
  }

  .description_lesson_name {
    font-size: 22px;
    font-weight: bold;
  }

  .description_lesson_type {
    margin: 0 10px;
  }

  .description_lesson_time {
    margin: 13px 0;
    font-size: 14px;
    font-weight: bold;
  }

  .description_lesson_location {
    margin: 0;
    font-size: 16px;
  }

  .block_teacher_information {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .teacher_cell_img.mobile {
    margin: 0;
    width: 70px;
    height: 70px;
  }

  .teacher_link {
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: color linear .2s;
  }

  .block_teacher_name {
    margin: 7px 0 10px 0;
    padding: 5px 10px;
    font-size: 16px;
    border: 1px solid #cecfd0;
    border-radius: 20px;
  }

  .mobile-group-span {
    padding-right: 5px;
  }

  .mobile-teacher-span:nth-child(2) {
    padding-right: 30px;
  }

  .lecture_row {
    border-left: 8px solid #52f652;
  }

  .lab_work_row {
    border-left: 8px solid #fd4b4b;
  }

  .practice_row {
    border-left: 8px solid #ffb024;
  }

  .consultation_row {
    border-left: 8px solid #52b7f6;
  }

  .exam_row {
    border-left: 8px solid #1812d5;
  }
}

@media screen  and ( max-width: 430px) {
  .schedule-table_mobile {
    margin-top: 40px;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    max-width: 320px;
  }

  .mobile-card {
    margin-bottom: 35px;
    width: 320px;
    border: 1px solid #cecfd0;
  }

  .mobile-table-block {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .card-inner {
    padding-top: 20px;
  }

  .card-text.discipline-name {
    font-weight: 500;
    font-size: 20px;
    color: #494A4A;
  }

  .card-text-key {
    color: #494A4A;
    padding-right: 5px;
  }

  .card-text {
    padding-left: 15px;
    padding-bottom: 10px;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #505050;
  }

  .no-lesson-img {
    width: 90%;
    max-width: 90%;
    height: auto;
  }

  .lecture_row {
    border-left: 8px solid #52f652;
  }

  .lab_work_row {
    border-left: 8px solid #fd4b4b;
  }

  .practice_row {
    border-left: 8px solid #ffb024;
  }

  .consultation_row {
    border-left: 8px solid #52b7f6;
  }

  .exam_row {
    border-left: 8px solid #1812d5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Schedule/ScheduleComponents/StudentsTable/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,MAAM;AACR;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,oCAAoC;AACpC,oCAAoC;AACpC,IAAI;;AAEJ;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,4BAA4B;EAC9B;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,cAAc;IACd,YAAY;EACd;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".schedule-table-block {\n  background-color: #F5F5F5;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  overflow-x: auto;\n}\n\n.no-lesson-img {\n  width: 100%;\n  max-width: 100%;\n  height: auto;\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n  height: 5px;\n}\n\n::-webkit-scrollbar-track {\n  background: #ebebeb;\n  border: 4px solid transparent;\n  background-clip: content-box;\n  top: 0;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #495471;\n  border-radius: 29px;\n}\n\n.schedule-table {\n  background-color: #434C63;\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.schedule-table_mobile {\n  display: none;\n}\n\n.table-header {\n  height: 60px;\n  font-size: 18px;\n  background-color: #434C63;\n}\n\n.table-header th:first-child {\n  border-top-left-radius: 12px;\n}\n\n.table-header th:last-child {\n  border-top-right-radius: 12px;\n}\n\n.table-header_item {\n  padding: 20px 20px;\n  color: #FFFFFF;\n  border-right: 1px solid #ffffff;\n}\n\n.table-body_row {\n  position: relative;\n}\n\n.table-body_row_item {\n  height: 60px;\n  text-align: center;\n  background-color: white;\n  border: 1px solid #E2E8F0;\n}\n\n.table-body_row_item.lesson_number {\n  width: 4%;\n}\n\n.lecture_row {\n  border-left: 5px solid #52f652;\n}\n\n.lab_work_row {\n  border-left: 5px solid #fd4b4b;\n}\n\n.practice_row {\n  border-left: 5px solid #ffb024;\n}\n\n.consultation_row {\n  border-left: 5px solid #52b7f6;\n}\n\n.exam_row {\n  border-left: 5px solid #1812d5;\n}\n\n/*.table-body_row_item.no_lessons {*/\n/*  border-left: 8px solid #a2a2a2;*/\n/*}*/\n\n.teacher_link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color linear .2s;\n}\n\n.teacher_link:hover {\n  color: #ffd03f;\n  text-decoration: underline;\n}\n\n.teacher_cell_img {\n  margin-right: 5px;\n  width: 45px;\n  height: 45px;\n}\n\n.teacher_cell_img:hover {\n  cursor: pointer;\n}\n\n.MONDAY, .WEDNESDAY, .FRIDAY, .SUNDAY {\n  background-color: #FFFFFF;\n}\n\n.TUESDAY, .THURSDAY, .SATURDAY {\n  background-color: #f1f1f1;\n}\n\n@media screen  and (max-width: 520px) {\n  .schedule-table-block {\n    overflow-x: hidden;\n  }\n\n  .schedule-table {\n    display: none;\n  }\n\n  .schedule-table_mobile {\n    margin-top: 40px;\n    margin-bottom: 40px;\n    display: flex;\n    flex-direction: column;\n    max-width: 420px;\n  }\n\n  .mobile-table-container {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .mobile-card {\n    margin-bottom: 35px;\n    width: 420px;\n    border: 1px solid #cecfd0;\n  }\n\n  .block_no_lessons {\n    margin: 0 auto;\n    padding: 20px 0;\n  }\n\n  .card-divider {\n    margin-bottom: 20px;\n    width: 100%;\n    height: 1px;\n    background-color: #a2a2a2;\n  }\n\n  .card-inner {\n    padding-top: 30px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n\n  .card-text.discipline-name {\n    font-weight: 500;\n    font-size: 24px;\n    color: #494A4A;\n  }\n\n  .card-text-key {\n    color: #494A4A;\n    padding-right: 5px;\n  }\n\n  .card-text {\n    padding-left: 28px;\n    padding-bottom: 20px;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 22px;\n    color: #505050;\n  }\n\n  .block_description_name {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: start;\n  }\n\n  .description_lesson_name {\n    font-size: 22px;\n    font-weight: bold;\n  }\n\n  .description_lesson_type {\n    margin: 0 10px;\n  }\n\n  .description_lesson_time {\n    margin: 13px 0;\n    font-size: 14px;\n    font-weight: bold;\n  }\n\n  .description_lesson_location {\n    margin: 0;\n    font-size: 16px;\n  }\n\n  .block_teacher_information {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .teacher_cell_img.mobile {\n    margin: 0;\n    width: 70px;\n    height: 70px;\n  }\n\n  .teacher_link {\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    transition: color linear .2s;\n  }\n\n  .block_teacher_name {\n    margin: 7px 0 10px 0;\n    padding: 5px 10px;\n    font-size: 16px;\n    border: 1px solid #cecfd0;\n    border-radius: 20px;\n  }\n\n  .mobile-group-span {\n    padding-right: 5px;\n  }\n\n  .mobile-teacher-span:nth-child(2) {\n    padding-right: 30px;\n  }\n\n  .lecture_row {\n    border-left: 8px solid #52f652;\n  }\n\n  .lab_work_row {\n    border-left: 8px solid #fd4b4b;\n  }\n\n  .practice_row {\n    border-left: 8px solid #ffb024;\n  }\n\n  .consultation_row {\n    border-left: 8px solid #52b7f6;\n  }\n\n  .exam_row {\n    border-left: 8px solid #1812d5;\n  }\n}\n\n@media screen  and ( max-width: 430px) {\n  .schedule-table_mobile {\n    margin-top: 40px;\n    margin-bottom: 0;\n    display: flex;\n    align-items: center;\n    max-width: 320px;\n  }\n\n  .mobile-card {\n    margin-bottom: 35px;\n    width: 320px;\n    border: 1px solid #cecfd0;\n  }\n\n  .mobile-table-block {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .card-inner {\n    padding-top: 20px;\n  }\n\n  .card-text.discipline-name {\n    font-weight: 500;\n    font-size: 20px;\n    color: #494A4A;\n  }\n\n  .card-text-key {\n    color: #494A4A;\n    padding-right: 5px;\n  }\n\n  .card-text {\n    padding-left: 15px;\n    padding-bottom: 10px;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 22px;\n    color: #505050;\n  }\n\n  .no-lesson-img {\n    width: 90%;\n    max-width: 90%;\n    height: auto;\n  }\n\n  .lecture_row {\n    border-left: 8px solid #52f652;\n  }\n\n  .lab_work_row {\n    border-left: 8px solid #fd4b4b;\n  }\n\n  .practice_row {\n    border-left: 8px solid #ffb024;\n  }\n\n  .consultation_row {\n    border-left: 8px solid #52b7f6;\n  }\n\n  .exam_row {\n    border-left: 8px solid #1812d5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
